import React, { useEffect } from 'react';
import { useData, useTexts } from './data';
import tracker from './analytics/tracker';

const ARCHIVE_START_YEAR = 2025;

function FunctionCompletedScreen() {
  const { time } = useData();
  const TEXTS = useTexts();
  const currentYear = time.appYear;

  const archiveYears = [];
  for (let y = currentYear; y >= ARCHIVE_START_YEAR; y--) {
    archiveYears.push(y);
  }

  useEffect(() => {
    tracker.pageViewCompleted();
  }, []);

  return (
    <div
      className="d-flex align-items-center justify-content-center px-3"
      style={{
        minHeight: '100dvh',
        background:
          'linear-gradient(135deg, #1a0000 0%, #4a0e0e 50%, #2d0a0a 100%)',
      }}
    >
      <div className="text-center" style={{ maxWidth: '420px' }}>
        <div style={{ fontSize: '2rem' }}>🪔</div>
        <h6
          className="fw-bold mb-0"
          style={{ color: '#f5c842', fontFamily: 'serif' }}
        >
          {TEXTS.TEMPLE_NAME}
        </h6>
        <small style={{ color: '#d4a528', fontSize: '0.7rem' }}>
          {TEXTS.TEMPLE_CELEBRATION}
        </small>

        <div
          className="p-3 rounded-3 my-3"
          style={{
            background: 'rgba(245, 200, 66, 0.1)',
            border: '1px solid rgba(245, 200, 66, 0.3)',
          }}
        >
          <h5 className="fw-bold mb-1" style={{ color: '#f5c842' }}>
            {TEXTS.FUNCTION_COMPLETED_TITLE}
          </h5>
          <small style={{ color: '#e0c68a' }}>
            {TEXTS.FUNCTION_COMPLETED_MESSAGE}
          </small>
        </div>

        <small className="fw-bold d-block mb-2" style={{ color: '#e8b830' }}>
          {TEXTS.FUNCTION_COMPLETED_ARCHIVES_LABEL}
        </small>
        <div className="d-grid gap-2">
          {archiveYears.map((year) => (
            <a
              key={year}
              href={`https://kondarangihills.com/app/${year}/`}
              className="btn btn-sm fw-bold"
              onClick={() => tracker.archiveClick(year)}
              style={{
                background: 'linear-gradient(135deg, #f5c842, #d4a528)',
                color: '#1a0000',
                border: 'none',
              }}
            >
              {year} {TEXTS.FUNCTION_COMPLETED_BUTTON}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FunctionCompletedScreen;
